import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../../../App'

const Status = ({ data }) => {
  const navigate = useNavigate()
  const { user } = useContext(UserContext)

  const trackingLink = (code) => {
    if (data.details.carrier_code === 'dao') {
      window.open(`https://dao.as/find-din-pakke/?stregkode=${code}`, '_blank').focus()
    } else if (data.details.carrier_code === 'pdk') {
      window.open(`https://portal.postnord.com/tracking/`, '_blank').focus()
    } else if (data.details.carrier_code === 'gls') {
      window.open(`https://gls-group.com/DK/da/find-pakke`, '_blank').focus()
    } else if (data.details.carrier_code === 'bring') {
      window.open(`https://tracking.bring.com/tracking/${code}`, '_blank').focus()
    }
  }

  return (
    <div className="buyerDetails flex flex-col flex-wrap gap-5 shadow-lg p-10 w-full lg:w-fit box-border text-white bg-gradient-to-b from-emerald-600 to-emerald-700 bg-size-200 bg-pos-0">
      <h2 className="text-sm md:text-base font-bold">Oversigt</h2>
      <div className="gap-y-8 flex flex-col justify-between h-full flex-[1]">
        <div className="flex flex-col gap-y-8">
          <div className="w-full">
            <label for="name" class="block text-sm font-semibold mb-2">Status</label>
            <h2 className="text-sm">{data.status === 0 ? (data.deliveryType !== 3 ? "Ikke afsendt" : "Afhentes af køber") : data.status === 1 ? "Afsendt" : data.status === 2 ? "Leveret" : data.status === 3 ? "Afsluttet" : "Annulleret"}</h2>
          </div>
          {data.buyer._id === user._id && data.status === 0 && data.deliveryType !== 3 ?
            <div className="w-full">
              <label for="name" class="block text-sm font-semibold mb-2">Modtagelsesgaranti</label>
              <div className="flex gap-2 relative items-center max-w-96">
                <h2 className="text-sm">{((data.timeToSend <= 48) ? data.timeToSend + (data.timeToSend !== 1 ? " timer" : " time") : Math.ceil(data.timeToSend/24) + " dage") + " tilbage"}</h2>
                <div className="flex group flex-wrap-reverse" tabindex="0">
                  <div className="q-mark cursor-pointer group-focus:text-gray-100">
                    <svg class="w-4 h-4 hover:text-gray-100" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg><span class="sr-only">Show information</span>
                  </div>
                  <div className="z-10 text-black invisible opacity-0 group-hover:visible group-hover:opacity-100 group-focus:visible group-focus:opacity-100 transition-opacity duration-100 absolute top-[20px] w-full left-0">
                    <div class="q-text right-0 top-[20px] w-full text-sm bg-white border border-gray-200 rounded-lg shadow-sm">
                      <div class="px-3 py-2 bg-gray-100 border-b border-gray-200 rounded-t-lg dark:border-gray-600 dark:bg-gray-700">
                          <h3 class="font-semibold">Modtagelsesgaranti</h3>
                      </div>
                      <div class="px-3 py-2 flex flex-col gap-2">
                        <p>Bogen skal afsendes med posten <span className="font-semibold">senest 5 dage efter</span> købet er sket.</p>
                        <hr></hr>
                        <p>Overholdes dette ikke, refunderes pengene til dig.</p>
                      </div>
                      <div data-popper-arrow></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          :
            ""}
          {data.deliveryType !== 3 ?
            <div className="w-full">
              <label for="name" class="block text-sm font-semibold mb-2">Sporingsnummer</label>
              <h2 className="text-sm cursor-pointer hover:text-emerald-600 transition-[] underline w-fit" onClick={() => trackingLink(data.details.pkg_no)}>
                {data.details.pkg_no}
              </h2>
            </div>
          :
            <div className="w-full">
              <label for="name" class="block text-sm font-semibold mb-2">Afhentningsadresse</label>
              <h2 className="text-sm">{data.details.pickup_address.line1}</h2>
              <h2 className="text-sm">{data.details.pickup_address.postal_code} {data.details.pickup_address.city}</h2>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default Status